<template>
  <div class="ticket-solicitacao-candidatos-root">
  <div v-if="embedded">
    <v-alert v-if="!idTipoTicketAgencia" type="warning" dense outlined class="mb-4">
      {{ $t('ticketSolicitacaoCandidatos.alerts.tipoTicketMissing') }}
    </v-alert>
    <v-form ref="form" v-model="formValid" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="form.solicitante_email"
            value="solicitante_email"
            :label="$t('ticketSolicitacaoCandidatos.fields.solicitante')"
            dense outlined
            hide-details="auto"
            :rules="[v => !!(v && String(v).trim()) || $t('ticketSolicitacaoCandidatos.validation.solicitanteRequired')]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-autocomplete
            v-model="empresa"
            :items="empresas"
            item-text="razao_social"
            item-value="id_empresa"
            :label="$t('ticketSolicitacaoCandidatos.fields.empresa')"
            dense outlined
            hide-details="auto"
            :rules="[v => !!v || $t('ticketSolicitacaoCandidatos.validation.empresaRequired')]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-autocomplete
            v-model="form.id_agencia_emprego"
            :items="agenciasFiltradas"
            item-text="nome"
            item-value="id_agencia_emprego"
            :label="$t('ticketSolicitacaoCandidatos.fields.agencia')"
            dense outlined
            hide-details="auto"
            :rules="[v => !!v || $t('ticketSolicitacaoCandidatos.validation.agenciaRequired')]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-autocomplete
            v-model="form.id_area_apoio"
            :items="areasApoioComOpcaoNao"
            :item-text="areaApoioItemText"
            item-value="id_area_apoio"
            :label="$t('ticketSolicitacaoCandidatos.fields.areaApoio')"
            dense outlined
            hide-details="auto"
            :rules="[areaApoioRule]"
          />
        </v-col>
        <v-col v-if="areasCluster.length" cols="12" sm="12" md="12">
          <v-autocomplete
            v-model="form.id_areas"
            :items="areasCluster"
            :item-text="areaClusterItemText"
            item-value="id_area"
            :label="$t('ticketSolicitacaoCandidatos.fields.areasPlanejamento')"
            :hint="$t('ticketSolicitacaoCandidatos.fields.areasPlanejamentoHint')"
            persistent-hint
            prepend-inner-icon="mdi-vector-square"
            dense outlined
            multiple
            chips
            small-chips
            deletable-chips
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-autocomplete
            v-model="form.id_unidades"
            :items="unidades"
            :label="$t('ticketSolicitacaoCandidatos.fields.unidades')"
            :item-text="unidadeItemText"
            item-value="id_unidade"
            dense outlined
            hide-details="auto"
            multiple
            chips
            small-chips
            deletable-chips
            :rules="[v => (Array.isArray(v) && v.length > 0) || $t('ticketSolicitacaoCandidatos.validation.unidadesRequired')]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-file-input
            v-model="arquivo"
            class="solicitacao-candidatos-arquivo"
            :label="$t('ticketSolicitacaoCandidatos.fields.arquivo')"
            dense outlined
            hide-details="auto"
            show-size
            prepend-icon="mdi-paperclip"
            accept=".csv,.txt,.xlsx,.xls"
            :rules="[arquivoRule]"
            @change="onCsvFileInput"
          >
            <template #append-outer>
              <v-btn
                type="button"
                text
                color="primary"
                class="solicitacao-candidatos-csv-template-btn"
                @click="downloadCsvTemplate"
              >
                <v-icon left small>mdi-download</v-icon>
                {{ $t('ticketSolicitacaoCandidatos.downloadCsvTemplate') }}
              </v-btn>
            </template>
          </v-file-input>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-switch v-model="form.pcd" :label="$t('ticketSolicitacaoCandidatos.fields.pcd')" color="primary" hide-details="auto" />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-switch v-model="form.validar_linha_stem" :label="$t('ticketSolicitacaoCandidatos.fields.validarLinhaStem')" color="primary" hide-details="auto" />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-switch v-model="form.validar_estudante" :label="$t('ticketSolicitacaoCandidatos.fields.validarEstudante')" color="primary" hide-details="auto" />
        </v-col>
      </v-row>
      <div v-if="!hideSubmitButton" class="d-flex justify-end mt-2">
        <v-btn type="button" color="primary" :loading="loadingSave || loadingParse" :disabled="!idTipoTicketAgencia" @click="submit">
          {{ $t('ticketSolicitacaoCandidatos.submit') }}
        </v-btn>
      </div>
    </v-form>
  </div>
  <v-container v-else max-width="900px" style="margin-top: 2%">
    <v-card outlined class="elevation-2">
      <v-card-title class="headline" style="color: #4a4a4a">
        {{ $t('ticketSolicitacaoCandidatos.title') }}
      </v-card-title>
      <v-card-text>
        <v-alert v-if="!idTipoTicketAgencia" type="warning" dense outlined class="mb-4">
          {{ $t('ticketSolicitacaoCandidatos.alerts.tipoTicketMissing') }}
        </v-alert>
        <v-form ref="form" v-model="formValid" @submit.prevent="submit">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="form.solicitante_email"
                value="solicitante_email"
                :label="$t('ticketSolicitacaoCandidatos.fields.solicitante')"
                dense outlined
                hide-details="auto"
                :rules="[v => !!(v && String(v).trim()) || $t('ticketSolicitacaoCandidatos.validation.solicitanteRequired')]"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="empresa"
                :items="empresas"
                item-text="razao_social"
                item-value="id_empresa"
                :label="$t('ticketSolicitacaoCandidatos.fields.empresa')"
                dense outlined
                hide-details="auto"
                :rules="[v => !!v || $t('ticketSolicitacaoCandidatos.validation.empresaRequired')]"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="form.id_agencia_emprego"
                :items="agenciasFiltradas"
                item-text="nome"
                item-value="id_agencia_emprego"
                :label="$t('ticketSolicitacaoCandidatos.fields.agencia')"
                dense outlined
                hide-details="auto"
                :rules="[v => !!v || $t('ticketSolicitacaoCandidatos.validation.agenciaRequired')]"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="form.id_area_apoio"
                :items="areasApoioComOpcaoNao"
                :item-text="areaApoioItemText"
                item-value="id_area_apoio"
                :label="$t('ticketSolicitacaoCandidatos.fields.areaApoio')"
                dense outlined
                hide-details="auto"
                :rules="[areaApoioRule]"
              />
            </v-col>
            <v-col v-if="areasCluster.length" cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="form.id_areas"
                :items="areasCluster"
                :item-text="areaClusterItemText"
                item-value="id_area"
                :label="$t('ticketSolicitacaoCandidatos.fields.areasPlanejamento')"
                :hint="$t('ticketSolicitacaoCandidatos.fields.areasPlanejamentoHint')"
                persistent-hint
                prepend-inner-icon="mdi-vector-square"
                dense outlined
                multiple
                chips
                small-chips
                deletable-chips
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="form.id_unidades"
                :items="unidades"
                :label="$t('ticketSolicitacaoCandidatos.fields.unidades')"
                :item-text="unidadeItemText"
                item-value="id_unidade"
                dense outlined
                hide-details="auto"
                multiple
                chips
                small-chips
                deletable-chips
                :rules="[v => (Array.isArray(v) && v.length > 0) || $t('ticketSolicitacaoCandidatos.validation.unidadesRequired')]"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="arquivo"
                class="solicitacao-candidatos-arquivo"
                :label="$t('ticketSolicitacaoCandidatos.fields.arquivo')"
                dense outlined
                hide-details="auto"
                show-size
                prepend-icon="mdi-paperclip"
                accept=".csv,.txt,.xlsx,.xls"
                :rules="[arquivoRule]"
                @change="onCsvFileInput"
              >
                <template #append-outer>
                  <v-btn
                    type="button"
                    text
                    color="primary"
                    class="solicitacao-candidatos-csv-template-btn"
                    @click="downloadCsvTemplate"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    {{ $t('ticketSolicitacaoCandidatos.downloadCsvTemplate') }}
                  </v-btn>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch v-model="form.pcd" :label="$t('ticketSolicitacaoCandidatos.fields.pcd')" color="primary" hide-details="auto" />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch v-model="form.validar_linha_stem" :label="$t('ticketSolicitacaoCandidatos.fields.validarLinhaStem')" color="primary" hide-details="auto" />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-switch v-model="form.validar_estudante" :label="$t('ticketSolicitacaoCandidatos.fields.validarEstudante')" color="primary" hide-details="auto" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn type="button" color="primary" :loading="loadingSave || loadingParse" :disabled="!idTipoTicketAgencia" @click="submit">
          {{ $t('ticketSolicitacaoCandidatos.submit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>

  <v-dialog v-model="csvPreviewOpen" max-width="1280" scrollable persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t('ticketSolicitacaoCandidatos.preview.title') }}
      </v-card-title>
      <v-card-text>
        <p class="body-2 mb-2">
          {{ $t('ticketSolicitacaoCandidatos.preview.summary', { total: csvPreviewRows.length, errors: csvPreviewErrorCount }) }}
        </p>
        <v-alert v-if="csvPreviewErrorCount > 0" type="warning" dense outlined class="mb-3">
          {{ $t('ticketSolicitacaoCandidatos.preview.resolveBeforeConfirm') }}
        </v-alert>
        <v-data-table
          dense
          item-key="_previewKey"
          :headers="csvPreviewHeaders"
          :items="csvPreviewRows"
          :items-per-page="15"
          class="elevation-1"
          :footer-props="{ itemsPerPageOptions: [10, 15, 25, 50] }"
        >
          <template #item.status="{ item }">
            <v-chip v-if="item.linha_tem_erro" small label color="error" text-color="white">
              {{ $t('ticketSolicitacaoCandidatos.preview.withErrors') }}
            </v-chip>
            <v-chip v-else small label color="success" text-color="white">
              {{ $t('ticketSolicitacaoCandidatos.preview.ok') }}
            </v-chip>
          </template>
          <template #item.erros="{ item }">
            <span class="caption">{{ formatPreviewErrors(item) }}</span>
          </template>
          <template #item.acoes="{ item }">
            <div v-if="item.linha_tem_erro" class="d-flex flex-wrap justify-center" style="gap: 2px">
              <v-btn x-small text color="primary" @click="openCsvRowEdit(item)">
                {{ $t('button.edit') }}
              </v-btn>
              <v-btn x-small text color="error" @click="deleteCsvPreviewRow(item)">
                {{ $t('button.remove') }}
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn text :disabled="loadingSave" @click="cancelCsvPreview">
          {{ $t('ticketSolicitacaoCandidatos.preview.back') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="loadingSave"
          :disabled="loadingParse || csvPreviewErrorCount > 0"
          @click="confirmCsvPreview"
        >
          {{ $t('ticketSolicitacaoCandidatos.preview.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="csvEditDialog" max-width="560" scrollable persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t('ticketSolicitacaoCandidatos.preview.editTitle') }}
      </v-card-title>
      <v-card-text>
        <v-alert v-if="csvEditStructuralMsg" type="warning" dense outlined class="mb-3">
          {{ csvEditStructuralMsg }}
        </v-alert>
        <v-text-field
          v-model="csvEditForm.nome_completo"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.nome')"
          dense
          outlined
          class="mb-2"
        />
        <v-text-field
          v-model="csvEditForm.rua"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.rua')"
          dense
          outlined
          class="mb-2"
        />
        <v-text-field
          v-model="csvEditForm.numero"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.numero')"
          dense
          outlined
          class="mb-2"
        />
        <v-text-field
          v-model="csvEditForm.bairro"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.bairro')"
          dense
          outlined
          class="mb-2"
        />
        <v-text-field
          v-model="csvEditForm.cidade"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.cidade')"
          dense
          outlined
          class="mb-2"
        />
        <v-text-field
          v-model="csvEditForm.cep"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.cep')"
          dense
          outlined
          class="mb-2"
        />
        <v-text-field
          v-model="csvEditForm.turno_desejado"
          :label="$t('ticketSolicitacaoCandidatos.preview.cols.turno')"
          dense
          outlined
        />
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="closeCsvRowEdit">{{ $t('button.cancel') }}</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="saveCsvRowEdit">{{ $t('ticketSolicitacaoCandidatos.preview.saveRow') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import { formatUnidadeLabel } from '@/utils/unidadeLabel';

const AGENCY_TICKET_TYPE_NAME = 'SOLICITAÇÃO DE CANDIDATOS (AGÊNCIA)';

/** Form value for explicit "sem área de apoio"; sent to API as `id_area_apoio: null`. */
const AREA_APOIO_NONE_VALUE = '__area_apoio_none__';

/** Must match api/utils/parsePreCandidatosTicketCsv.js HEADER_TO_FIELD after normalization (delimiter ;). CEP rules: normalizeCepBrForCsv in that file. */
const CSV_PRECANDIDATOS_HEADER_CELLS = [
  'Nome completo',
  'Rua',
  'Numero',
  'Bairro',
  'Cidade',
  'CEP',
  'Turno desejado'];

const CSV_MAX_NOME = 300;
const CSV_MAX_RUA = 300;
const CSV_MAX_NUMERO = 30;
const CSV_MAX_BAIRRO = 120;
const CSV_MAX_CIDADE = 120;
const CSV_MAX_CEP_STORE = 20;
const CSV_MAX_TURNO = 120;

function csvTruncate(str, max) {
  if (str == null) return null;
  const s = String(str);
  return s.length <= max ? s : s.slice(0, max);
}

/** Same rules as normalizeCepBrForCsv in api/utils/parsePreCandidatosTicketCsv.js */
function csvNormalizeCepBrForCsv(cepRaw) {
  if (cepRaw === undefined || cepRaw === null) {
    return { ok: false };
  }
  const trimmed = String(cepRaw).trim();
  if (trimmed === '') {
    return { ok: false };
  }
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 0 || digits.length > 8) {
    return { ok: false };
  }
  const value = digits.padStart(8, '0');
  if (value.length !== 8 || !/^\d{8}$/.test(value)) {
    return { ok: false };
  }
  return { ok: true, value };
}

function csvEscapeCell(val, delimiter) {
  const s = val == null ? '' : String(val);
  if (/["\n\r]/.test(s) || s.includes(delimiter)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** Empresa do usuário logado, usada para pré-preencher a seleção. */
function initialEmpresaFromSession() {
  try {
    const u = JSON.parse(sessionStorage.getItem('user') || 'null');
    return u && u.id_empresa != null && u.id_empresa !== '' ? u.id_empresa : null;
  } catch (e) {
    return null;
  }
}

export default {
  name: 'TicketsSolicitacaoCandidatos',
  props: {
    embedded: { type: Boolean, default: false },
    hideSubmitButton: { type: Boolean, default: false },
  },
  data() {
    return {
      user: null,
      token: null,
      formValid: true,
      loadingSave: false,
      empresa: initialEmpresaFromSession(),
      empresas: [],
      tiposTickets: [],
      idTipoTicketAgencia: null,
      unidades: [],
      /** Áreas de Planejamento comuns (não Zona de Risco) com as unidades de cada uma. */
      areasCluster: [],
      areasApoio: [],
      agencias: [],
      arquivo: null,
      csvPreviewOpen: false,
      csvPreviewRows: [],
      csvPreviewDelimiter: ';',
      csvPreviewParsed: false,
      confirmedCsvPreview: false,
      loadingParse: false,
      csvEditDialog: false,
      csvEditRowKey: null,
      csvEditStructuralMsg: '',
      csvEditForm: {},
      form: {
        solicitante_email: '',
        id_agencia_emprego: null,
        id_area_apoio: null,
        id_areas: [],
        id_unidades: [],
        pcd: false,
        validar_linha_stem: false,
        validar_estudante: false,
      },
    };
  },
  computed: {
    agenciasFiltradas() {
      return (this.agencias || []).filter((a) => (a.ativo === 1 || a.ativo === true));
    },
    areasApoioFiltradas() {
      return (this.areasApoio || []).filter((a) => a.ativo === 1 || a.ativo === true);
    },
    areasApoioComOpcaoNao() {
      const noneRow = {
        id_area_apoio: AREA_APOIO_NONE_VALUE,
        codigo: '',
        nome: this.$t('ticketSolicitacaoCandidatos.areaApoioNone'),
        ativo: 1,
      };
      return [noneRow, ...this.areasApoioFiltradas];
    },
    csvPreviewErrorCount() {
      return (this.csvPreviewRows || []).filter((r) => r.linha_tem_erro).length;
    },
    csvPreviewHeaders() {
      return [
        { text: '#', value: 'line_number', width: '56px' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.nome'), value: 'nome_completo' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.rua'), value: 'rua' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.numero'), value: 'numero' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.bairro'), value: 'bairro' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.cidade'), value: 'cidade' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.cep'), value: 'cep' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.turno'), value: 'turno_desejado' },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.status'), value: 'status', sortable: false },
        { text: this.$t('ticketSolicitacaoCandidatos.preview.cols.erros'), value: 'erros', sortable: false },
        {
          text: this.$t('ticketSolicitacaoCandidatos.preview.cols.acoes'),
          value: 'acoes',
          sortable: false,
          width: '148px',
          align: 'center',
        }];
    },
  },
  watch: {
    empresa() {
      if (!this.resolveAgenciaFromUser()) {
        this.form.id_agencia_emprego = null;
      }
      this.form.id_area_apoio = null;
      this.form.id_areas = [];
      this.form.id_unidades = [];
      this.loadAgencias();
    },
    /** Área escolhida soma as unidades dela (só as que o usuário enxerga); tirar a área não tira unidades. */
    'form.id_areas'(novas, antigas) {
      const antes = new Set((antigas || []).map(Number));
      const visiveis = new Set((this.unidades || []).map((u) => Number(u.id_unidade)));
      const atuais = (this.form.id_unidades || []).map(Number);
      const somar = [];
      (novas || []).map(Number).filter((id) => !antes.has(id)).forEach((idArea) => {
        const area = this.areasCluster.find((a) => Number(a.id_area) === idArea);
        ((area && area.id_unidades) || []).map(Number).forEach((idUnidade) => {
          if (visiveis.has(idUnidade) && !atuais.includes(idUnidade) && !somar.includes(idUnidade)) somar.push(idUnidade);
        });
      });
      if (somar.length) this.form.id_unidades = atuais.concat(somar);
    },
    loadingSave(val) {
      this.$emit('update:loadingSave', val);
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user') || 'null');
    this.token = sessionStorage.getItem('api');
    this.bootstrap();
  },
  methods: {
    getSelectedCsvFile() {
      if (!this.arquivo) return null;
      return Array.isArray(this.arquivo) ? this.arquivo[0] : this.arquivo;
    },
    hasSelectedCsvFile() {
      return !!this.getSelectedCsvFile();
    },
    formatPreviewErrors(item) {
      if (!item || !item.errors) return '';
      return Object.values(item.errors)
        .filter((m) => m != null && String(m).trim() !== '')
        .join('; ');
    },
    onCsvFileInput() {
      if (this.loadingSave) return;
      this.csvPreviewParsed = false;
      this.confirmedCsvPreview = false;
    },
    downloadCsvTemplate() {
      const d = ';';
      const line = CSV_PRECANDIDATOS_HEADER_CELLS.map((c) => csvEscapeCell(c, d)).join(d);
      const blob = new Blob(['\ufeff' + `${line}\r\n`], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'modelo_candidatos_solicitacao.csv';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    cancelCsvPreview() {
      this.csvPreviewOpen = false;
    },
    confirmCsvPreview() {
      if (this.csvPreviewErrorCount > 0) {
        return;
      }
      if (this.$refs.form && !this.$refs.form.validate()) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSolicitacaoCandidatos.validation.fillAllFields'),
        });
        return;
      }
      this.csvPreviewOpen = false;
      this.confirmedCsvPreview = true;
      this.$nextTick(() => {
        this.executeTicketInsert();
      });
    },
    openCsvRowEdit(item) {
      this.csvEditRowKey = item._previewKey;
      const hasUnder = Object.keys(item.errors || {}).some((k) => k.startsWith('_'));
      this.csvEditStructuralMsg = hasUnder
        ? this.$t('ticketSolicitacaoCandidatos.preview.structuralRowHint')
        : '';
      this.csvEditForm = {
        nome_completo: item.nome_completo != null ? String(item.nome_completo) : '',
        rua: item.rua != null ? String(item.rua) : '',
        numero: item.numero != null ? String(item.numero) : '',
        bairro: item.bairro != null ? String(item.bairro) : '',
        cidade: item.cidade != null ? String(item.cidade) : '',
        cep: item.cep != null ? String(item.cep) : '',
        turno_desejado: item.turno_desejado != null ? String(item.turno_desejado) : '',
      };
      this.csvEditDialog = true;
    },
    closeCsvRowEdit() {
      this.csvEditDialog = false;
      this.csvEditRowKey = null;
      this.csvEditStructuralMsg = '';
      this.csvEditForm = {};
    },
    saveCsvRowEdit() {
      const row = this.csvPreviewRows.find((r) => r._previewKey === this.csvEditRowKey);
      if (!row) {
        this.closeCsvRowEdit();
        return;
      }
      row.nome_completo = String(this.csvEditForm.nome_completo || '').trim();
      row.rua = String(this.csvEditForm.rua || '').trim();
      row.numero = String(this.csvEditForm.numero || '').trim();
      row.bairro = String(this.csvEditForm.bairro || '').trim();
      row.cidade = String(this.csvEditForm.cidade || '').trim();
      row.cep = String(this.csvEditForm.cep || '').trim();
      row.turno_desejado = String(this.csvEditForm.turno_desejado || '').trim();
      this.revalidatePreviewRow(row);
      this.closeCsvRowEdit();
    },
    deleteCsvPreviewRow(item) {
      const idx = this.csvPreviewRows.findIndex((r) => r._previewKey === item._previewKey);
      if (idx >= 0) {
        this.csvPreviewRows.splice(idx, 1);
      }
    },
    rowValidationMsg(key, params) {
      return this.$t(`ticketSolicitacaoCandidatos.preview.rowValidation.${key}`, params);
    },
    revalidatePreviewRow(row) {
      const lineNumber = row.line_number;
      const preserved = {};
      Object.keys(row.errors || {}).forEach((k) => {
        if (k.startsWith('_')) preserved[k] = row.errors[k];
      });
      const fieldErrors = {};
      const nome = row.nome_completo != null ? String(row.nome_completo).trim() : '';
      const rua = row.rua != null ? String(row.rua).trim() : '';
      const numero = row.numero != null ? String(row.numero).trim() : '';
      const bairro = row.bairro != null ? String(row.bairro).trim() : '';
      const cidade = row.cidade != null ? String(row.cidade).trim() : '';
      const cepRaw = row.cep != null ? String(row.cep).trim() : '';
      const turno = row.turno_desejado != null ? String(row.turno_desejado).trim() : '';
      const t = (key, extra) =>
        this.rowValidationMsg(key, Object.assign({ lineNumber }, extra || {}));

      if (!nome) {
        fieldErrors.nome_completo = t('requiredNome');
      } else if (nome.length > CSV_MAX_NOME) {
        fieldErrors.nome_completo = t('nomeTooLong', { max: CSV_MAX_NOME });
      }
      if (!rua) {
        fieldErrors.rua = t('requiredRua');
      } else if (rua.length > CSV_MAX_RUA) {
        fieldErrors.rua = t('ruaTooLong', { max: CSV_MAX_RUA });
      }
      if (numero.length > CSV_MAX_NUMERO) {
        fieldErrors.numero = t('numeroTooLong', { max: CSV_MAX_NUMERO });
      }
      if (bairro.length > CSV_MAX_BAIRRO) {
        fieldErrors.bairro = t('bairroTooLong', { max: CSV_MAX_BAIRRO });
      }
      if (!cidade) {
        fieldErrors.cidade = t('requiredCidade');
      } else if (cidade.length > CSV_MAX_CIDADE) {
        fieldErrors.cidade = t('cidadeTooLong', { max: CSV_MAX_CIDADE });
      }
      const cepNorm = cepRaw ? csvNormalizeCepBrForCsv(cepRaw) : { ok: false };
      if (!cepRaw) {
        fieldErrors.cep = t('requiredCep');
      } else if (!cepNorm.ok) {
        fieldErrors.cep = t('invalidCep');
      }
      if (!turno) {
        fieldErrors.turno_desejado = t('requiredTurno');
      } else if (turno.length > CSV_MAX_TURNO) {
        fieldErrors.turno_desejado = t('turnoTooLong', { max: CSV_MAX_TURNO });
      }

      const errors = Object.assign({}, preserved, fieldErrors);
      const linhaTemErro = Object.keys(errors).length > 0;

      this.$set(row, 'nome_completo', csvTruncate(nome, CSV_MAX_NOME));
      this.$set(row, 'rua', csvTruncate(rua, CSV_MAX_RUA));
      this.$set(row, 'numero', csvTruncate(numero || null, CSV_MAX_NUMERO));
      this.$set(row, 'bairro', csvTruncate(bairro || null, CSV_MAX_BAIRRO));
      this.$set(row, 'cidade', csvTruncate(cidade, CSV_MAX_CIDADE));
      this.$set(
        row,
        'cep',
        csvTruncate(cepNorm.ok ? cepNorm.value : String(cepRaw).trim(), CSV_MAX_CEP_STORE)
      );
      this.$set(row, 'turno_desejado', csvTruncate(turno, CSV_MAX_TURNO));
      this.$set(row, 'errors', errors);
      this.$set(row, 'linha_tem_erro', linhaTemErro);
    },
    buildCsvFileFromPreviewRows() {
      const d = this.csvPreviewDelimiter || ';';
      const lines = [CSV_PRECANDIDATOS_HEADER_CELLS.map((c) => csvEscapeCell(c, d)).join(d)];
      (this.csvPreviewRows || []).forEach((row) => {
        const cells = [
          row.nome_completo ?? '',
          row.rua ?? '',
          row.numero ?? '',
          row.bairro ?? '',
          row.cidade ?? '',
          row.cep ?? '',
          row.turno_desejado ?? ''].map((c) => csvEscapeCell(c, d));
        lines.push(cells.join(d));
      });
      const blob = new Blob([lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
      const orig = this.getSelectedCsvFile();
      const name = orig && orig.name ? String(orig.name) : 'candidatos.csv';
      return new File([blob], name, { type: 'text/csv' });
    },
    async openCsvPreview() {
      const file = this.getSelectedCsvFile();
      if (!file) return;
      this.csvPreviewParsed = false;
      this.csvPreviewDelimiter = ';';
      this.loadingParse = true;
      try {
        const fd = new FormData();
        fd.append('file', file, file.name || 'candidatos.csv');
        const response = await apiController.request(apiController.endpoints.parsecsvprecandidatosticket, {
          data: fd,
          silent: true,
        });
        if (response.data && response.data.erro) {
          EventBus.$emit('show-alert', {
            tipo: 'error',
            mensagem: (response.data.mensagem || '').toString(),
          });
          return;
        }
        this.csvPreviewRows = (response.data.rows || []).map((r, i) => ({
          ...r,
          _previewKey: `p_${i}_${r.line_number}_${Math.random().toString(36).slice(2, 11)}`,
        }));
        this.csvPreviewParsed = true;
        this.csvPreviewOpen = true;
      } catch (e) {
        const msg = e.response && e.response.data && (e.response.data.mensagem || e.response.data.message);
        if (msg) {
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: String(msg) });
        } else {
          EventBus.$emit('show-error', { error: e });
        }
      } finally {
        this.loadingParse = false;
      }
    },
    arquivoRule(value) {
      const file = value == null ? null : Array.isArray(value) ? value[0] : value;
      if (!file) return this.$t('ticketSolicitacaoCandidatos.validation.arquivoRequired');
      const name = String(file.name || '').toLowerCase();
      const type = String(file.type || '').toLowerCase();
      const extCsv = name.endsWith('.csv') || name.endsWith('.txt');
      const extXlsx = name.endsWith('.xlsx') || name.endsWith('.xls');
      const typeCsvOk = type === '' || type === 'text/csv' || type === 'text/plain' || type === 'application/csv';
      const typeXlsxOk =
        type === '' ||
        type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        type === 'application/vnd.ms-excel';
      if ((extCsv && typeCsvOk) || (extXlsx && typeXlsxOk)) return true;
      return this.$t('ticketSolicitacaoCandidatos.validation.arquivoTipoInvalido');
    },
    areaApoioRule(v) {
      const okNone = v === AREA_APOIO_NONE_VALUE;
      const n = v != null && v !== '' && v !== AREA_APOIO_NONE_VALUE ? Number(v) : NaN;
      const okId = Number.isFinite(n) && n > 0;
      return okNone || okId || this.$t('ticketSolicitacaoCandidatos.validation.areaApoioRequired');
    },
    async bootstrap() {
      await Promise.all([
        this.loadTiposTickets(),
        this.loadUnidades(),
        this.loadAreasCluster(),
        this.loadAreasApoio(),
        this.loadEmpresas(),
        this.loadSolicitantes(),
        this.enrichUserAgenciaIfNeeded()]);
      this.resolveTipoTicketAgencia();
      this.loadAgencias();
    },
    loadTiposTickets() {
      return apiController.request(apiController.endpoints.getallTipostickets, {
        onSuccess: (res) => {
          this.tiposTickets = res.data || [];
        },
      }).catch(() => {});
    },
    resolveTipoTicketAgencia() {
      const list = this.tiposTickets || [];
      if (list.length === 1) {
        this.idTipoTicketAgencia = list[0].id_tipo_ticket;
        return;
      }
      const row = list.find(
        (t) => String(t.nome_tipo_ticket || '').trim() === AGENCY_TICKET_TYPE_NAME,
      );
      this.idTipoTicketAgencia = row ? row.id_tipo_ticket : null;
    },
    loadUnidades() {
      return apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (res) => {
          const raw = res.data || [];
          this.unidades = raw;
          if (this.unidades.length === 1 && !(this.form.id_unidades || []).length) {
            this.form.id_unidades = [this.unidades[0].id_unidade];
          }
        },
      }).catch(() => {});
    },
    loadAreasCluster() {
      return apiController.request(apiController.endpoints.getallAreasmapa, {
        query: { zona_risco: 0, incluir_unidades: 1 },
        silent: true,
        onSuccess: (res) => {
          this.areasCluster = Array.isArray(res.data) ? res.data : [];
        },
      }).catch(() => {
        this.areasCluster = [];
      });
    },
    areaClusterItemText(item) {
      if (!item) return '';
      const nome = [item.cod_area, item.nome_area].filter(Boolean).join(' - ');
      const n = Array.isArray(item.id_unidades) ? item.id_unidades.length : 0;
      return nome + ' (' + this.$tc('ticketSolicitacaoCandidatos.fields.areasPlanejamentoUnidades', n, { count: n }) + ')';
    },
    loadAgencias() {
      return apiController.request(apiController.endpoints.getallAgenciasemprego, {
        onSuccess: (res) => {
          this.agencias = res.data || [];
          this.applyAgenciaFromUser();
        },
      }).catch(() => {});
    },
    loadEmpresas() {
      return apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (res) => {
          this.empresas = (res.data || []).filter((e) => e.ativa === 1 || e.ativa === true);
        },
      }).catch(() => {});
    },
    loadAreasApoio() {
      return apiController.request(apiController.endpoints.getallAreasapoio, {
        onSuccess: (res) => {
          this.areasApoio = res.data || [];
        },
      }).catch(() => {});
    },
    unidadeItemText(item) {
      return formatUnidadeLabel(item);
    },
    areaApoioItemText(item) {
      if (!item) return '';
      if (item.id_area_apoio === AREA_APOIO_NONE_VALUE) {
        return this.$t('ticketSolicitacaoCandidatos.areaApoioNone');
      }
      const c = item.codigo != null ? String(item.codigo).trim() : '';
      const n = item.nome != null ? String(item.nome).trim() : '';
      if (c && n) return `${c} – ${n}`;
      return n || c || '';
    },
    loadSolicitantes() {
      this.form.solicitante_email = this.resolveSolicitanteFromUser();
    },
    resolveSolicitanteFromUser() {
      const u = this.user || {};
      const emailRec = u.email_recuperacao != null ? String(u.email_recuperacao).trim() : '';
      const login = u.login != null ? String(u.login).trim() : '';
      const email = u.email != null ? String(u.email).trim() : '';
      return emailRec || login || email || (u.nome_usuario != null ? String(u.nome_usuario).trim() : '') || '';
    },
    resolveAgenciaFromUser() {
      const u = this.user || {};
      const id = u.id_agencia_emprego;
      if (id == null || id === '') return null;
      const n = Number(id);
      return Number.isFinite(n) && n > 0 ? n : null;
    },
    async enrichUserAgenciaIfNeeded() {
      if (this.resolveAgenciaFromUser() || !this.user || !this.user.login) return;
      try {
        const response = await apiController.request(apiController.endpoints.getallUsuarios, {
          data: {
            page: 1,
            rowsPerPage: 10,
            total: 'true',
            filter_login: this.user.login,
          },
          silent: true,
        });
        const items = response.data && (response.data.items || response.data);
        const row = Array.isArray(items)
          ? items.find((u) => Number(u.id_usuario) === Number(this.user.id_usuario))
          : null;
        if (row && row.id_agencia_emprego != null) {
          this.user = Object.assign({}, this.user, { id_agencia_emprego: row.id_agencia_emprego });
        }
      } catch (e) {
        // optional enrichment for sessions created before login included id_agencia_emprego
      }
    },
    applyAgenciaFromUser() {
      const id = this.resolveAgenciaFromUser();
      if (!id) return;
      const exists = (this.agenciasFiltradas || []).some(
        (a) => Number(a.id_agencia_emprego) === id,
      );
      if (exists) {
        this.form.id_agencia_emprego = id;
      }
    },
    uploadArquivoIfAny() {
      if (!this.arquivo) return Promise.resolve(null);
      const selectedFile = Array.isArray(this.arquivo) ? this.arquivo[0] : this.arquivo;
      if (!selectedFile) return Promise.resolve(null);
      const originalName = (selectedFile.name && String(selectedFile.name).trim()) || 'file';
      const stem = originalName
        .replace(/\.[^.]+$/, '')
        .replace(/[^a-zA-Z0-9._-]/g, '_')
        .slice(0, 120);
      const filename = `c_${Date.now()}_${Math.random().toString(36).slice(2, 11)}_${stem || 'file'}`;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const uploadData = {
            file: e.target.result,
            filename,
            folder: 'candidatos',
          };
          apiController.request(apiController.endpoints.uploadImg, {
            data: uploadData,
            silent: true,
            onSuccess: (response) => {
              const d = response.data;
              if (d && !d.error) {
                const stored =
                  (typeof d.filename === 'string' && d.filename.trim() !== ''
                    ? d.filename.trim()
                    : null) ||
                  (typeof d.path === 'string'
                    ? d.path.replace(/^.*[/\\]/, '')
                    : null);
                if (stored) {
                  resolve({ originalName, storedName: stored });
                  return;
                }
              }
              reject(new Error(d?.message || 'upload'));
            },
            onError: reject,
          }).catch(() => {});
        };
        reader.onerror = () => reject(new Error('read'));
        reader.readAsDataURL(selectedFile);
      });
    },
    async submit() {
      if (this.loadingSave || this.loadingParse) {
        return;
      }
      if (this.$refs.form && !this.$refs.form.validate()) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSolicitacaoCandidatos.validation.fillAllFields'),
        });
        return;
      }
      if (!this.idTipoTicketAgencia) {
        EventBus.$emit('show-alert', { tipo: 'warning', mensagem: this.$t('ticketSolicitacaoCandidatos.alerts.tipoTicketMissing') });
        return;
      }
      if (this.hasSelectedCsvFile() && !this.confirmedCsvPreview) {
        await this.openCsvPreview();
        return;
      }
      await this.executeTicketInsert();
    },
    async executeTicketInsert() {
      if (this.loadingSave) {
        return;
      }
      if (this.$refs.form && !this.$refs.form.validate()) {
        this.confirmedCsvPreview = false;
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSolicitacaoCandidatos.validation.fillAllFields'),
        });
        return;
      }
      if (!this.hasSelectedCsvFile()) {
        this.confirmedCsvPreview = false;
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSolicitacaoCandidatos.validation.arquivoRequired'),
        });
        return;
      }
      const areaOk = this.areaApoioRule(this.form.id_area_apoio);
      if (areaOk !== true) {
        this.confirmedCsvPreview = false;
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: typeof areaOk === 'string' ? areaOk : this.$t('ticketSolicitacaoCandidatos.validation.areaApoioRequired'),
        });
        return;
      }
      if (this.hasSelectedCsvFile() && this.csvPreviewParsed && this.csvPreviewErrorCount > 0) {
        this.confirmedCsvPreview = false;
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSolicitacaoCandidatos.preview.resolveBeforeConfirm'),
        });
        return;
      }
      let rebuiltFile = null;
      if (this.csvPreviewParsed && this.csvPreviewRows && this.getSelectedCsvFile()) {
        rebuiltFile = this.buildCsvFileFromPreviewRows();
      }
      this.loadingSave = true;
      try {
        if (rebuiltFile) {
          this.arquivo = rebuiltFile;
        }
        const arquivoMeta = await this.uploadArquivoIfAny();
        const importarPre = !!(arquivoMeta && arquivoMeta.storedName);
        const idsUnidades = (this.form.id_unidades || []).map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0);
        const solicitacaoPayload = {
          id_agencia_emprego: this.form.id_agencia_emprego,
          id_area_apoio:
            this.form.id_area_apoio === AREA_APOIO_NONE_VALUE
              ? null
              : this.form.id_area_apoio != null && this.form.id_area_apoio !== ''
                ? Number(this.form.id_area_apoio)
                : null,
          solicitante_email: this.form.solicitante_email,
          // Tipo de solicitação é definido na edição do card.
          id_tipo_solicitacao: null,
          id_unidades: idsUnidades,
          id_unidade: idsUnidades.length ? idsUnidades[0] : null,
          id_areas: (this.form.id_areas || []).map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0),
          nome_arquivo_original: arquivoMeta ? arquivoMeta.originalName : null,
          nome_arquivo_armazenado: arquivoMeta ? arquivoMeta.storedName : null,
          pcd: this.form.pcd,
          validar_linha_stem: this.form.validar_linha_stem,
          validar_estudante: this.form.validar_estudante,
          importar_pre_candidatos: importarPre,
        };
        const body = {
          titulo: `Solicitação de candidatos - ${this.form.solicitante_email}`,
          corpo: `PCD: ${this.form.pcd ? this.$t("selectOptions.yes") : this.$t("selectOptions.no")}\nValidar linha tronco: ${this.form.validar_linha_stem ? this.$t("selectOptions.yes") : this.$t("selectOptions.no")}\nValidar aprendiz: ${this.form.validar_estudante ? this.$t("selectOptions.yes") : this.$t("selectOptions.no")}`,
          id_categoria: null,
          id_empresa: this.empresa,
          id_usuario_inclusao: this.user.id_usuario,
          id_usuario_ultima_alteracao: this.user.id_usuario,
          nome_usuario_solicitante: this.form.solicitante_email,
          id_usuario_atribuido: null,
          id_tipo_ticket: this.idTipoTicketAgencia,
          id_tipo_solicitacao: null,
          id_familia_atendimento: null,
          id_tipo_atendimento: null,
          id_servico: null,
          id_equipes: [],
          id_equipamentos: [],
          id_kits: [],
          id_veiculos: [],
          id_tipos_equipamento: [],
          id_tipos_kits: [],
          id_usuarios_visualizadores: [],
          solicitacao_candidatos_agencia: solicitacaoPayload,
        };
        const response = await apiController.request(apiController.endpoints.insertTicketsolicitacaocandidatosagencia, {
          data: body,
          silent: true,
        });
        if (response.data && response.data.erro) {
          EventBus.$emit('show-alert', {
            tipo: 'error',
            mensagem: (response.data.mensagem || '').toString(),
          });
          return;
        }
        const id_ticket = response.data && (response.data.id_ticket != null ? response.data.id_ticket : response.data.insertId);
        if (id_ticket == null) {
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: this.$t('ticketSolicitacaoCandidatos.extensionTicketIdMissing') });
          return;
        }
        EventBus.$emit('show-alert', {
          tipo: 'success',
          mensagem: this.$t('ticketSolicitacaoCandidatos.success'),
        });
        this.resetFormPartial();
        this.$emit('saved', { id_ticket });
      } catch (e) {
        const msg = e.response && e.response.data && (e.response.data.mensagem || e.response.data.message);
        if (msg) {
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: String(msg) });
        } else {
          EventBus.$emit('show-error', { error: e });
        }
      } finally {
        this.loadingSave = false;
        this.confirmedCsvPreview = false;
      }
    },
    resetFormPartial() {
      this.confirmedCsvPreview = false;
      this.csvPreviewOpen = false;
      this.csvPreviewRows = [];
      this.csvPreviewParsed = false;
      this.csvPreviewDelimiter = ';';
      this.closeCsvRowEdit();
      this.form = {
        titulo: '',
        corpo: '',
        solicitante_email: this.resolveSolicitanteFromUser(),
        id_agencia_emprego: null,
        id_area_apoio: null,
        id_areas: [],
        id_unidades: [],
        pcd: false,
        validar_linha_stem: false,
        validar_estudante: false,
      };
      this.applyAgenciaFromUser();
      this.arquivo = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped>
/*
 * Fields use hide-details="auto", so there is no empty v-messages reserve below them:
 * top-align the button and offset it to center on the 40px dense outlined control.
 */
.ticket-solicitacao-candidatos-root >>> .solicitacao-candidatos-arquivo .v-input__append-outer {
  align-self: flex-start;
  margin-top: 2px;
}
</style>
